import Views from '../../views/entry/orgUnitAdminUser/OrgUnitAdminUserViews';
import getInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';

const getEntryReports = (viewName, route) => {
  const isCurrent = viewName === Views.OME_MEET_ENTRY_REPORTS;

  const isComplete = true;

  const arePrerequisitesDone = true;

  const item = route === '' ? getInitialStateOmeRoute(Views.OME_MEET_ENTRY_REPORTS) : getInitialStateMeetRoute(Views.OME_MEET_ENTRY_REPORTS);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getEntryReports;